// extracted by mini-css-extract-plugin
export default {"ArticleDateTagContainer":"ArticleDateTag_ArticleDateTagContainer__1exiH","inverted":"ArticleDateTag_inverted__RyarO"};